import { useCallback, useEffect, useRef, useState } from 'react';
import type { IScreensLogging } from '../../../../../api/types';
import { bridge } from '../../../../../utils';

export const useLogDisplayCarousel = (
  logging?: IScreensLogging,
  isVisible?: boolean,
  isAwaitingDataChange?: boolean,
) => {
  const logged = useRef(false);
  // 외곽 필터로 carousel 데이터가 보존되는 경우 logging ref가 그대로 유지되어
  // [logging] effect가 안 도는 케이스를 커버. resetDisplayCarousel 호출 시
  // counter bump로 강제 재실행.
  const [resetCounter, setResetCounter] = useState(0);

  const resetDisplayCarousel = useCallback(() => {
    logged.current = false;
    setResetCounter(c => c + 1);
  }, []);

  useEffect(() => {
    logged.current = false;
  }, [logging]);

  useEffect(() => {
    if (
      logged.current ||
      !isVisible ||
      !logging?.analytics ||
      isAwaitingDataChange
    ) {
      return;
    }
    logged.current = true;

    bridge.logAnalyticsEvent({
      name: 'DISPLAY_CAROUSEL',
      analytics: logging.analytics,
      ably_only_log: logging.ably_only_log,
    });
  }, [isVisible, logging, resetCounter, isAwaitingDataChange]);

  return { resetDisplayCarousel };
};
